export enum RENTM_FE_BE_MAPPING_FIELD {
    id = 'id',
    firstName = 'firstName',
    lastName = 'lastName',
    mobilePhone = 'mobilePhone',
    officePhone = 'officePhone',
    companyName = 'companyName',
    email = 'email',
    access = 'access',
    ssoID = 'ssoID',
    region = 'region',
    suppliers = 'suppliers',
}
export class RenTM {
    id: number;
    firstName: string;
    lastName: string;
    officePhone: string;
    mobilePhone: string;
    companyName: string;
    email: string;
    access: any[];
    ssoID: string;
    region: string;
    suppliers: boolean;

    constructor(params: any = {}, parsed: boolean = true) {

        if (parsed) {
            this.parseFromResp(params);
        } else {
            this.id = params.id;
            this.firstName = params.firstName;
            this.lastName = params.lastName;
            this.mobilePhone = params.mobilePhone;
            this.officePhone = (params.officePhone || '');
            this.companyName = params.companyName;
            this.email = params.email;
            this.access = params.access;
            this.access[6].items = params.items;
            this.ssoID = params.ssoID;
            this.region = params.region;
            this.suppliers = params.suppliers;
        }
    }

    parseFromResp(respObject: any = {}) {
        this.id = respObject[RENTM_FE_BE_MAPPING_FIELD.id];
        this.firstName = respObject[RENTM_FE_BE_MAPPING_FIELD.firstName];
        this.lastName = respObject[RENTM_FE_BE_MAPPING_FIELD.lastName];
        this.mobilePhone = respObject[RENTM_FE_BE_MAPPING_FIELD.mobilePhone];
        this.officePhone = respObject[RENTM_FE_BE_MAPPING_FIELD.officePhone];
        this.companyName = respObject[RENTM_FE_BE_MAPPING_FIELD.companyName];
        this.email = respObject[RENTM_FE_BE_MAPPING_FIELD.email];
        this.access = respObject[RENTM_FE_BE_MAPPING_FIELD.access];
        this.region = respObject[RENTM_FE_BE_MAPPING_FIELD.region];
        this.ssoID = respObject[RENTM_FE_BE_MAPPING_FIELD.ssoID];
        return this;
    }

    convertToReqBody() {
        const body = {};
        body[RENTM_FE_BE_MAPPING_FIELD.id] = this.id;
        body[RENTM_FE_BE_MAPPING_FIELD.mobilePhone] = this.mobilePhone || '';
        body[RENTM_FE_BE_MAPPING_FIELD.firstName] = this.firstName || '';
        body[RENTM_FE_BE_MAPPING_FIELD.lastName] = this.lastName || '';
        body[RENTM_FE_BE_MAPPING_FIELD.officePhone] = this.officePhone || '';
        body[RENTM_FE_BE_MAPPING_FIELD.companyName] = this.companyName || '';
        body[RENTM_FE_BE_MAPPING_FIELD.email] = this.email || '';
        body[RENTM_FE_BE_MAPPING_FIELD.access] = {
            lsp: {
                name: 'LSP',
                value: this.access
            },
            suppliers: {
                name: 'SUPPLIERS',
                value: this.suppliers
            }
        };
        body[RENTM_FE_BE_MAPPING_FIELD.ssoID] = this.ssoID || '';
        body[RENTM_FE_BE_MAPPING_FIELD.region] = this.region || '';
        return body;

    }
}
